import { compare, equals as _equals, includesSlice as _includesSlice, startsWith as _startsWith, endsWith as _endsWith, split as _split, chunk as _chunk, concat, copy, } from "../bytes.ts";
Uint8Array.copy = copy;
Uint8Array.concat = concat;
Uint8Array.compare = compare;
Uint8Array.prototype.equals = function equals(another) {
    return _equals(this, another);
};
Uint8Array.prototype.includesSlice = function includesSlice(slice) {
    return _includesSlice(this, slice);
};
Uint8Array.prototype.startsWith = function startsWith(prefix) {
    return _startsWith(this, prefix);
};
Uint8Array.prototype.endsWith = function endsWith(suffix) {
    return _endsWith(this, suffix);
};
Uint8Array.prototype.split = function split(delimiter) {
    return _split(this, delimiter);
};
Uint8Array.prototype.chunk = function chunk(length) {
    return _chunk(this, length);
};
//# sourceMappingURL=uint8array.js.map